
// BOTTOM SHEET SWIPE VELOCITY DETECTION
export const FAST_SWIPE_VELOCITY_THRESHOLD = 1.4 as const; // píxeles por ms (aumentado)
export const MIN_SWIPE_DISTANCE = 80 as const; // píxeles mínimos para considerar un swipe (aumentado)
export const MIN_SWIPE_TIME = 50 as const; // ms mínimos para evitar detección instantánea
export const LEVEL_PROXIMITY_THRESHOLD = 100 as const; // píxeles de tolerancia para considerar "cerca" de un nivel

// SCROLL SERVICE
export const SCROLL_OFFSET = 175 as const;

// DEFAULT IMG SERVICE
export const DEFAULT_LANGUAGE = 'es' as const;
export const MAX_IMAGES_PER_CATEGORY = 4 as const;